// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-products-product-add-to-compare-icon-button-button-cbzae{color:#bbb!important;height:40px}.components-products-product-add-to-compare-icon-button-button-cbzae:hover,.components-products-product-add-to-compare-icon-button-buttonActive-bngpk{color:var(--color-primary)!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "components-products-product-add-to-compare-icon-button-button-cbzae",
	"buttonActive": "components-products-product-add-to-compare-icon-button-buttonActive-bngpk"
};
module.exports = ___CSS_LOADER_EXPORT___;
